import {
  IonApp,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonSpinner,
  IonTabBar,
  IonTabButton,
  IonTabs,
  setupIonicReact
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route } from 'react-router-dom';
import { home, videocam, settings } from 'ionicons/icons';
import { useAuth0 } from '@auth0/auth0-react';

import Home from './pages/Home';
import Callback from './pages/Callback';
import StreamList from './pages/StreamList';
import RegisterCamera from './pages/RegisterCamera';
import MovementsPage from "./pages/MovementsPage";
import Landing from './pages/Landing';


import './theme/variables.css';
import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';
import '@ionic/react/css/palettes/dark.system.css';

setupIonicReact();

const App: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return (
      <IonApp>
        <div style={{
          display: 'flex',
          minHeight: '100vh',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{ textAlign: 'center' }}>
            <IonSpinner name="crescent" />
            <div>Carregando autenticação...</div>
          </div>
        </div>
      </IonApp>
    );
  }

  return (
    <IonApp>
      <IonReactRouter>
        <Route exact path="/callback" component={Callback} />
        {isAuthenticated ? (
          <IonRouterOutlet id="main">
            <Route
              exact
              path="/movements/:streamId/:cameraName"
              render={({ match }) => (
                <MovementsPage key={match.params.streamId + match.params.cameraName} />
              )}
            />
            <Route path={["/home", "/stream-list", "/register-camera"]} exact={false}>
              <IonTabs>
                <IonRouterOutlet>
                  <Route exact path="/home" component={Home} />
                  <Route exact path="/stream-list" component={StreamList} />
                  <Route exact path="/register-camera" component={RegisterCamera} />
                </IonRouterOutlet>
                <IonTabBar slot="bottom">
                  <IonTabButton tab="home" href="/home">
                    <IonIcon icon={home} />
                    <IonLabel>Início</IonLabel>
                  </IonTabButton>
                  <IonTabButton tab="stream-list" href="/stream-list">
                    <IonIcon icon={videocam} />
                    <IonLabel>Stream</IonLabel>
                  </IonTabButton>
                  <IonTabButton tab="register-camera" href="/register-camera">
                    <IonIcon icon={settings} />
                    <IonLabel>Configuração</IonLabel>
                  </IonTabButton>
                </IonTabBar>
              </IonTabs>
            </Route>
            <Redirect exact from="/" to="/home" />
          </IonRouterOutlet>
        ) : (
          <IonRouterOutlet id="main">
            <Route exact path="/" component={Landing} />
            <Route render={() => <Redirect to="/" />} />
          </IonRouterOutlet>
        )}
      </IonReactRouter>
    </IonApp>
  );
};

export default App;
